/**
 * hellopanda-tabs
 */
import { hellopanda_func as $ } from '../../../assets/script/func.js';

const HELLOPANDA_TABS = {
  init: function() {

    // 전역 객체 생성
    window.hellopanda = window.hellopanda || {} ;
    window.hellopanda.block = window.hellopanda.block || {};
    window.hellopanda.block.tabs = window.hellopanda.block.tabs || {};

    document.addEventListener('DOMContentLoaded', function() {
  
      const tabContainers = document.querySelectorAll('.wp-block-hellopanda-tabs-block');
      tabContainers.forEach((container) => {
        
        const trigger = container.getAttribute('data-trigger') || 'mouseenter';
        let initialIndex = parseInt(container.getAttribute('data-initial'), 10) - 1;
        if (isNaN(initialIndex) || initialIndex < 0) initialIndex = 0; // 기본값 설정

        /**
         * 파라미터 데이터
         */
        const initparam = container.dataset.initparam || '' ;
        const paramvalue = $.gerParameter(initparam);
        if (paramvalue) initialIndex = $.getNumber(paramvalue) - 1;

        /**
         * 중복 탭 메뉴 허용
         */
        // const tabsMenu = container.querySelectorAll('.wp-block-hellopanda-tabs-button-block');
        // const tabsContent = container.querySelectorAll('.wp-block-hellopanda-tabs-content-block');
        const tabsMenu = Array.from(container.querySelectorAll('.wp-block-hellopanda-tabs-button-block')).filter(btn => {
          const closestBlock = btn.closest('.wp-block-hellopanda-tabs-block');
          return closestBlock === container;
        });
        const tabsContent = Array.from(container.querySelectorAll('.wp-block-hellopanda-tabs-content-block')).filter(btn => {
          const closestBlock = btn.closest('.wp-block-hellopanda-tabs-block');
          return closestBlock === container;
        });

        if (!container || tabsMenu.length === 0 || tabsContent.length === 0) {
          console.warn('Invalid tabs container or empty menu/content:', container);
          return;
        }
        if (initialIndex >= tabsMenu.length) initialIndex = 0; // 이니셜 번호가 버튼 수를 넘어가면 0으로 고정

        // 탭 기록
        const id = $.randomOnlyString(10);
        window.hellopanda.block.tabs[id] = {};

        // 이벤트 리스너 등록
        let ready = false;
        tabsMenu.forEach((tab, index) => {

          // 원본 컨텐츠를 기록
          const key = $.randomOnlyString(10);
          const target = tab.dataset.id || '';
          requestAnimationFrame(() => {
            setTimeout(() => {
              const style = window.getComputedStyle(tab) || {
                color: '',
                backgroundColor: '',
                borderTopColor: '',
                borderRightColor: '',
                borderBottomColor: '',
                borderLeftColor: '',
                fontWeight: '',
              };
              window.hellopanda.block.tabs[id][key] = {};
              window.hellopanda.block.tabs[id][key].origin = {
                color: style.color,
                backgroundColor: tab.style.backgroundColor?.includes('var') ? tab.style.backgroundColor : style.backgroundColor,
                borderTopColor: tab.style.borderTopColor?.includes('var') ? tab.style.borderTopColor : style.borderTopColor,
                borderRightColor: tab.style.borderRightColor?.includes('var') ? tab.style.borderRightColor : style.borderRightColor,
                borderBottomColor: tab.style.borderBottomColor?.includes('var') ? tab.style.borderBottomColor : style.borderBottomColor,
                borderLeftColor: tab.style.borderLeftColor?.includes('var') ? tab.style.borderLeftColor : style.borderLeftColor,
                fontWeight: style.fontWeight,
              }
              window.hellopanda.block.tabs[id][key].hover = {
                color: tab.dataset.hoverColor || '',
                backgroundColor: tab.dataset.hoverBackground || '',
                borderColor: tab.dataset.hoverBorder || '',
                fontWeight: tab.dataset.hoverFontWeight || '',
              }
              window.hellopanda.block.tabs[id][key].active = {
                color: tab.dataset.activeColor || '',
                backgroundColor: tab.dataset.activeBackground || '',
                borderColor: tab.dataset.activeBorder || '',
                fontWeight: tab.dataset.activeFontWeight || '',
              }

              // 초기 활성화 상태 설정
              if (!ready && target || index === initialIndex) {
                activateTab(container, initialIndex, tabsMenu, tabsContent, target, id, key, true);
                ready = true;
              }

            }, 1);
          });

          // 이벤트 등록
          tab.addEventListener('mouseenter', () => handleMouseEnter(tab, container, id, key));
          tab.addEventListener('mouseleave', () => handleMouseLeave(tab, container, index, id, key));
          tab.addEventListener(trigger, () => {
            activateTab(container, index, tabsMenu, tabsContent, target, id, key, false);
          });

        });
      
        /**
         * 컨테이너 가공 종료
         * window.getComputedStyle 버그 개선
         */
        requestAnimationFrame(() => {
          setTimeout(() => {
            container.classList.add('tab-initialized');
          }, 300);
        });
      
      });

      function activateTab(container, index, tabsMenu, tabsContent, target, id, key, initial) {
        tabsMenu.forEach((tab, idx) => {
          if (idx === index) {
            tab.classList.add('tabs-active-button');
            applyActiveStyles(tab, container, id, key);
          } else if (!initial) {
            tab.classList.remove('tabs-active-button');
            removeStyles(tab, id, key); // 비활성화된 탭의 스타일 초기화
          }
        });
        tabsContent.forEach((content, idx) => {
          const receive = content.dataset.id || '' ;
          if (target && target === receive || (!target && idx === index)) {
            content.classList.add('tabs-active-content');
          } else {
            content.classList.remove('tabs-active-content');
          }
        });
      }

      function handleMouseEnter(tab, container, id, key) {
        if (!tab.classList.contains('tabs-active-button')) {
          applyHoverStyles(tab, container, id, key);
        }
      }

      function handleMouseLeave(tab, container, index, id, key) {
        if (!tab.classList.contains('tabs-active-button')) {
          removeStyles(tab, id, key); // 원래 상태로 복원
        }
      }

      function applyHoverStyles(tab, container, id, key) {
        const style = window.hellopanda.block.tabs[id][key]?.hover;
        if (style) {
          if (style.color) tab.style.setProperty('color', style.color, 'important');
          if (style.backgroundColor) tab.style.setProperty('background-color', style.backgroundColor, 'important');
          if (style.borderColor) tab.style.setProperty('border-color', style.borderColor, 'important');
          if (style.fontWeight) tab.style.setProperty('font-weight', style.fontWeight, 'important');
        }
      }
      
      function applyActiveStyles(tab, container, id, key) {
        const style = window.hellopanda.block.tabs[id][key]?.active;
        if (style) {
          if (style.color) tab.style.setProperty('color', style.color, 'important');
          if (style.backgroundColor) tab.style.setProperty('background-color', style.backgroundColor, 'important');
          if (style.borderColor) tab.style.setProperty('border-color', style.borderColor, 'important');
          if (style.fontWeight) tab.style.setProperty('font-weight', style.fontWeight, 'important');
        }
      }

      function removeStyles(tab, id, key) {
        const style = window.hellopanda.block.tabs[id][key]?.origin;
        if (style) {
          tab.style.color = style.color;
          tab.style.backgroundColor = style.backgroundColor;
          tab.style.borderTopColor = style.borderTopColor;
          tab.style.borderRightColor = style.borderRightColor;
          tab.style.borderBottomColor = style.borderBottomColor;
          tab.style.borderLeftColor = style.borderLeftColor;
          tab.style.fontWeight = style.fontWeight;
        }
      }
      
    });
  }
};
HELLOPANDA_TABS.init();